import * as Device from "expo-device";
import * as Notifications from "expo-notifications";
import Constants from "expo-constants";

import { useEffect, useContext, createContext, useRef, useState } from "react";

import * as TaskManager from "expo-task-manager";

import { AuthContext } from "../context/AuthContext";
import { Platform } from "react-native";

export const NotifyContext = createContext();

class ErrorHelper {
  static errorTitle = (errorid) => {
    switch (errorid) {
      case 9:
        return "Fehlende Sensordaten";
      default:
        return "Abweichende Sensordaten";
    }
  };
  static errorText = (errorid) => {
    switch (errorid) {
      case 1:
        return "Kein Temperaturwert";
      case 2:
        return "Temperatur zu niedrig";
      case 3:
        return "Temperatur zu hoch";
      case 4:
        return "Kein Luftfeuchtigkeitswert";
      case 5:
        return "Luftfeuchtigkeit zu niedrig";
      case 6:
        return "Luftfeuchtigkeit zu hoch";
      case 7:
        return "Batteriespannung niedrig";
      case 8:
        return "Fehler Standortverifizierung";
      case 9:
        return "Fehlende Sensordaten";
    }
    return "";
  };

  static errorUnit = (errorid) => {
    switch (errorid) {
      case 2:
      case 3:
        return "°C";
      case 5:
      case 6:
        return "%";
      case 7:
        return "V";
      case 9:
        return "Werte";
    }
    return "";
  };

  static errorValue = (error) => {
    switch (error.errortyp) {
      case 2:
      case 3:
      case 5:
      case 6:
      case 7:
      case 9:
        return ` ${error.value} ${this.errorUnit(error.errortyp)}`;
    }
    return "";
  };

  /*
1- No Temperature
2- Low Temperature
3- High Temperature

4- No Humidity
5- Low Humidity
6- High Humidity

7- Low Voltage
8- Error Location

9- Fehlende Daten

*/
}

const testNotification = async (mute) => {
  await Notifications.scheduleNotificationAsync({
    content: {
      title: "Abweichende Sensordaten ⛔",
      body: `Temperatur zu hoch 5°C\r\nSensor: Testsensor\r\nStandort: Teststandort`,
      color: "#FF0000",
      sound: !mute,
      // priority : mute?Notifications.AndroidNotificationPriority.DEFAULT:Notifications.AndroidNotificationPriority.MAX,
      data: { data: null },
    },
    trigger: null,
  });
};

if (Platform.OS === "android") {
  Notifications.setNotificationHandler({
    handleNotification: async () => {
      return {
        priority: Notifications.AndroidNotificationPriority.MAX,
        shouldShowAlert: false,
        shouldPlaySound: false,
        shouldSetBadge: false,
      };
    },
  });
}

//Notifications.addNotificationResponseReceivedListener;

const registerForPushNotificationsAsync = async () => {
  let token;
  const { status: existingStatus } = await Notifications.getPermissionsAsync();
  let finalStatus = existingStatus;
  if (existingStatus !== "granted") {
    const { status } = await Notifications.requestPermissionsAsync();
    finalStatus = status;
  }
  if (finalStatus !== "granted") {
    //alert("Failed to get push token for push notification!");
    return;
  }

  if (Device.isDevice) {
    token = await Notifications.getExpoPushTokenAsync({
      projectId: Constants.expoConfig.extra.eas.projectId,
    });
    console.log(token);
  } else {
    //alert("Must use physical device for Push Notifications");
  }

  if (Platform.OS === "android") {
    Notifications.deleteNotificationChannelAsync(
      "expo_notifications_fallback_notification_channel"
    );
    Notifications.setNotificationChannelAsync("temperature", {
      name: "Temperaturabweichung",
      importance: Notifications.AndroidImportance.MAX,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: "#FF231F7C",
    });
    Notifications.setNotificationChannelAsync("voltage", {
      name: "Spannung niedrig",
      importance: Notifications.AndroidImportance.DEFAULT,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: "#FF231F7C",
    });
    Notifications.setNotificationChannelAsync("missing", {
      name: "Fehlende Werte",
      importance: Notifications.AndroidImportance.DEFAULT,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: "#FF231F7C",
    });
  }

  return token;
};

const PUSH_NOTIFY_TASK_NAME = "SENCONO_BACKGROUND_NOTIFY";

if (Platform.OS === "android") {
  TaskManager.defineTask(
    PUSH_NOTIFY_TASK_NAME,
    ({ data, error, executionInfo }) => {
      //Notifications.dismissNotificationAsync(data.notification.messageId);
      console.log(data);
      body = JSON.parse(data.notification.data.body);
      console.log(body);
      //FileLog.save(`Notify BG: ${data.notification.data.body}`);
    }
  );
}

const Notification = ({ children }) => {
  const { setNotifyToken, notifyToken } = useContext(AuthContext);
  const notificationListener = useRef();
  const responseListener = useRef();
  const ownListener = useRef();

  const addFGListener = (myListener) => {
    ownListener.current = myListener;
  };

  if (Platform.OS === "android") {
    useEffect(() => {
      registerForPushNotificationsAsync().then((token) => {
        token && setNotifyToken(token.data);
      });

      notificationListener.current =
        Notifications.addNotificationReceivedListener((notification) => {
          //          console.log(notification);
          //          console.log(notification.request.content.data);
          if (ownListener.current) ownListener.current(true, notification);
          //FileLog.save(`Notify FG: ${JSON.stringify(notification.request.content.data)}`);
        });

      responseListener.current =
        Notifications.addNotificationResponseReceivedListener((response) => {
          console.log(response);
        });

      Notifications.registerTaskAsync(PUSH_NOTIFY_TASK_NAME);
      return () => {
        Notifications.removeNotificationSubscription(
          notificationListener.current
        );
        Notifications.removeNotificationSubscription(responseListener.current);
        Notifications.unregisterTaskAsync(PUSH_NOTIFY_TASK_NAME);

        TaskManager.unregisterAllTasksAsync();
      };
    }, []);
  }

  return (
    <NotifyContext.Provider
      value={{
        testNotification,
        addFGListener,
      }}
    >
      {children}
    </NotifyContext.Provider>
  );
};

export default Notification;
